export function getHTML(text) {
    if (text) {
        // Remove HTML tags
        const result = text.replace(/<[^>]+>/g, ' ');

        // Decode HTML entities
        const doc = new DOMParser().parseFromString(result, "text/html");
        return doc.body.textContent || "";
    }
    return "";
  
}
